var map = {
	"./calendar-24.png": 8536,
	"./calendar-64.png": 7460,
	"./calendar-80.png": 750,
	"./clock-24.png": 4464,
	"./down-16.png": 5989,
	"./download-24.png": 1454,
	"./edit-24.png": 2066,
	"./exercise-64.png": 5576,
	"./health-book-64.png": 810,
	"./health-book-80.png": 1456,
	"./invoice-64.png": 1965,
	"./invoice-80.png": 6411,
	"./menu-vertical-24.png": 222,
	"./message-64.png": 8341,
	"./message-80.png": 7219,
	"./next-24.png": 2663,
	"./not-paid-24.png": 1296,
	"./paid-24.png": 1084,
	"./request-64.png": 1819,
	"./send-24.png": 8028,
	"./send-32.png": 513,
	"./up-16.png": 8340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5853;